import * as actionTypes from './actionTypes'

import companyAxios from '../../axios/company'
import passwordPolicyAxios from '../../axios/passwordPolicy'
import ldapServerAxios from '../../axios/ldapServer'
import emailServerAxios from '../../axios/emailServer'
import levelAxios from '../../axios/level'
import orgAxios from '../../axios/organization'
import positionAxios from '../../axios/position'
import positionGroupAxios from '../../axios/positionGroup'
import userAxios from '../../axios/user'
import orgLevelAxios from '../../axios/organizationLevel'
import criteriaAxios from '../../axios/criteria'
import empLevelAxios from '../../axios/employeeLevel'
import structureAxios from '../../axios/structure'
import structureTypeAxios from '../../axios/structureType'
import roleAxios from '../../axios/role'
import masterAxios from '../../axios/masterValue'
import appraisalItemAxios from '../../axios/appraisalItem'
import formAxios from '../../axios/form'
import uomAxios from '../../axios/uom'
import kpiTypeAxios from '../../axios/kpiType'
import perspectiveAxios from '../../axios/perspective'
import empAxios from '../../axios/employee'
import levelGroupAxios from '../../axios/levelGroup'
import dropDownAxios from '../../axios/appraisalDropdownOptions'
import competencyScoreAxios from '../../axios/competencyScore'
import baseAxios from '../../axios/base'
// import competencyScoreGroupAxios from '../../axios/competencyScoreGroup'

// import stageAxios from '../../axios/stage'

export const fetchCompanyOptions = filter => {
  return dispatch => {
    dispatch(fetchCompanyOptionsStart())
    companyAxios
      .get('/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchCompanyOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchCompanyOptionsFailed(error))
      })
  }
}

export const fetchCompanyOptionsStart = () => {
  return {
    type: actionTypes.FETCH_COMPANY_OPTIONS_START
  }
}

export const fetchCompanyOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_COMPANY_OPTIONS_SUCCESS,
    data
  }
}

export const fetchCompanyOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_COMPANY_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchCriteriaOptions = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchCriteriaOptionsStart())
    criteriaAxios
      .get('/dropdown', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchCriteriaOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchCriteriaOptionsFailed(error))
      })
  }
}

export const fetchCriteriaOptionsStart = () => {
  return {
    type: actionTypes.FETCH_CRITERIA_OPTIONS_START
  }
}

export const fetchCriteriaOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_CRITERIA_OPTIONS_SUCCESS,
    data
  }
}

export const fetchCriteriaOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_CRITERIA_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchParentCompanyOptions = () => {
  return dispatch => {
    dispatch(fetchParentCompanyOptionsStart())
    companyAxios
      .get('/dropdown')
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchParentCompanyOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(
          fetchParentCompanyOptionsSuccess([
            {
              company_id: '1',
              company_code: 'COMP1',
              company_name: 'Company 1'
            },
            {
              company_id: '2',
              company_code: 'COMP2',
              company_name: 'Company 2'
            },
            {
              company_id: '3',
              company_code: 'COMP3',
              company_name: 'Company 3'
            },
            {
              company_id: '4',
              company_code: 'COMP4',
              company_name: 'Company 4'
            },
            {
              company_id: '5',
              company_code: 'COMP5',
              company_name: 'Company 5'
            }
          ])
        )
        dispatch(fetchParentCompanyOptionsFailed(error))
      })
  }
}

export const fetchParentCompanyOptionsStart = () => {
  return {
    type: actionTypes.FETCH_PARENT_COMPANY_OPTIONS_START
  }
}

export const fetchParentCompanyOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_PARENT_COMPANY_OPTIONS_SUCCESS,
    data
  }
}

export const fetchParentCompanyOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_PARENT_COMPANY_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchPasswordPolicyOptions = () => {
  return dispatch => {
    dispatch(fetchPasswordPolicyOptionsStart())
    passwordPolicyAxios
      .get('/dropdown')
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchPasswordPolicyOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchPasswordPolicyOptionsFailed(error))
        dispatch(
          fetchPasswordPolicyOptionsSuccess([
            {
              password_policy_id: '1',
              password_policy_name: 'Policy 1'
            },
            {
              password_policy_id: '2',
              password_policy_name: 'Policy 2'
            },
            {
              password_policy_id: '3',
              password_policy_name: 'Policy 3'
            },
            {
              password_policy_id: '4',
              password_policy_name: 'Policy 4'
            },
            {
              password_policy_id: '5',
              password_policy_name: 'Policy 5'
            }
          ])
        )
      })
  }
}

export const fetchPasswordPolicyOptionsStart = () => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_START
  }
}

export const fetchPasswordPolicyOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_SUCCESS,
    data
  }
}

export const fetchPasswordPolicyOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchLdapServerOptions = () => {
  return dispatch => {
    dispatch(fetchLdapServerOptionsStart())
    ldapServerAxios
      .get('/dropdown')
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchLdapServerOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchLdapServerOptionsFailed(error))
        fetchParentCompanyOptionsSuccess([
          {
            ldap_server_id: '1',
            ldap_server_name: 'LDAP 1'
          },
          {
            ldap_server_id: '2',
            ldap_server_name: 'Company 2'
          },
          {
            ldap_server_id: '3',
            ldap_server_name: 'Company 3'
          },
          {
            ldap_server_id: '4',
            ldap_server_name: 'Company 4'
          },
          {
            ldap_server_id: '5',
            ldap_server_name: 'Company 5'
          }
        ])
      })
  }
}

export const fetchLdapServerOptionsStart = () => {
  return {
    type: actionTypes.FETCH_LDAP_SERVER_OPTIONS_START
  }
}

export const fetchLdapServerOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_LDAP_SERVER_OPTIONS_SUCCESS,
    data
  }
}

export const fetchLdapServerOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_LDAP_SERVER_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchEmailServerOptions = () => {
  return dispatch => {
    dispatch(fetchEmailServerOptionsStart())
    emailServerAxios
      .get('/dropdown')
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchEmailServerOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchEmailServerOptionsFailed(error))
      })
  }
}

export const fetchEmailServerOptionsStart = () => {
  return {
    type: actionTypes.FETCH_EMAIL_SERVER_OPTIONS_START
  }
}

export const fetchEmailServerOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_EMAIL_SERVER_OPTIONS_SUCCESS,
    data
  }
}

export const fetchEmailServerOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_EMAIL_SERVER_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchAppraisalYearOptions = () => {
  return dispatch => {
    dispatch(fetchAppraisalYearOptionsStart())
    let startYear = new Date().getFullYear() - 5
    let year = []
    for (let index = 0; index < 11; index++) {
      year.push({
        year_id: startYear + index,
        year_code: startYear + index,
        year_name: (startYear + index).toString()
      })
    }
    if (year) {
      dispatch(fetchAppraisalYearOptionsSuccess(year))
    } else {
      dispatch(fetchAppraisalYearOptionsFailed('Get year fail'))
    }
  }
}

export const fetchAppraisalYearOptionsStart = () => {
  return {
    type: actionTypes.FETCH_APPRAISAL_YEAR_OPTIONS_START
  }
}

export const fetchAppraisalYearOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_APPRAISAL_YEAR_OPTIONS_SUCCESS,
    data
  }
}

export const fetchAppraisalYearOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_APPRAISAL_YEAR_OPTIONS_FAILED,
    errorMessage
  }
}

// export const fetchParentLevelOptions = recordId => {
//   if (!recordId) return
//   return dispatch => {
//     dispatch(fetchParentLevelOptionsStart())
//     levelAxios
//       .get('/parent_level/dropdown/appraisal_type/' + recordId)
//       .then(response => {
//         if (response.status === 200) {
//           dispatch(fetchParentLevelOptionsSuccess(response.data.data))
//         }
//       })
//       .catch(error => {
//         dispatch(fetchParentLevelOptionsFailed(error))
//       })
//   }
// }

// export const fetchParentLevelOptionsStart = () => {
//   return {
//     type: actionTypes.FETCH_PARENT_LEVEL_OPTIONS_START
//   }
// }

// export const fetchParentLevelOptionsSuccess = data => {
//   return {
//     type: actionTypes.FETCH_PARENT_LEVEL_OPTIONS_SUCCESS,
//     data
//   }
// }

// export const fetchParentLevelOptionsFailed = errorMessage => {
//   return {
//     type: actionTypes.FETCH_PARENT_LEVEL_OPTIONS_FAILED,
//     errorMessage
//   }
// }

export const fetchLevelOptions = () => {
  return dispatch => {
    dispatch(fetchLevelOptionsStart())
    levelAxios
      .get('/dropdown')
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchLevelOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchLevelOptionsFailed(error))
      })
  }
}

export const fetchLevelOptionsStart = () => {
  return {
    type: actionTypes.FETCH_LEVEL_OPTIONS_START
  }
}

export const fetchLevelOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_LEVEL_OPTIONS_SUCCESS,
    data
  }
}

export const fetchLevelOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_LEVEL_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchAppraisalTypeOptions = () => {
  return dispatch => {
    dispatch(fetchAppraisalTypeOptionsStart())
    masterAxios
      .get('/appraisal_type')
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchAppraisalTypeOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchAppraisalTypeOptionsFailed(error))
      })
  }
}

export const fetchAppraisalTypeOptionsStart = () => {
  return {
    type: actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_START
  }
}

export const fetchAppraisalTypeOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_SUCCESS,
    data
  }
}

export const fetchAppraisalTypeOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchOrgLevelOptions = filter => {
  return dispatch => {
    dispatch(fetchOrgLevelOptionsStart())
    orgLevelAxios
      .get('/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchOrgLevelOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchOrgLevelOptionsFailed(error))
      })
  }
}

export const fetchOrgLevelOptionsStart = () => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_LEVEL_OPTIONS_START
  }
}

export const fetchOrgLevelOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_LEVEL_OPTIONS_SUCCESS,
    data
  }
}

export const fetchOrgLevelOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_LEVEL_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchOrganizationOptions = filterOptions => {
  let params = {}
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchOrganizationOptionsStart())
    orgAxios
      .get('/dropdown', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchOrganizationOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchOrganizationOptionsFailed(error))
      })
  }
}

export const fetchOrganizationOptionsStart = () => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_OPTIONS_START
  }
}

export const fetchOrganizationOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_OPTIONS_SUCCESS,
    data
  }
}

export const fetchOrganizationOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_OPTIONS_FAILED,
    errorMessage
  }
}

export const filterOrganizationOptions = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(filterOrganizationOptionsStart())
    orgAxios
      .get('/dropdown', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(filterOrganizationOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(filterOrganizationOptionsFailed(error))
      })
  }
}

export const filterOrganizationOptionsStart = () => {
  return {
    type: actionTypes.FILTER_ORGANIZATION_OPTIONS_START
  }
}

export const filterOrganizationOptionsSuccess = data => {
  return {
    type: actionTypes.FILTER_ORGANIZATION_OPTIONS_SUCCESS,
    data
  }
}

export const filterOrganizationOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FILTER_ORGANIZATION_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchEmpLevelOptions = filterOptions => {
  let params = {}
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchEmpLevelOptionsStart())
    empLevelAxios
      .get('/dropdown', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchEmpLevelOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchEmpLevelOptionsFailed(error))
      })
  }
}

export const fetchEmpLevelOptionsStart = () => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_LEVEL_OPTIONS_START
  }
}

export const fetchEmpLevelOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_LEVEL_OPTIONS_SUCCESS,
    data
  }
}

export const fetchEmpLevelOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_LEVEL_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchPositionOptions = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchPositionOptionsStart())
    positionAxios
      .get('/dropdown', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchPositionOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchPositionOptionsFailed(error))
      })
  }
}

export const fetchPositionOptionsStart = () => {
  return {
    type: actionTypes.FETCH_POSITION_OPTIONS_START
  }
}

export const fetchPositionOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_POSITION_OPTIONS_SUCCESS,
    data
  }
}

export const fetchPositionOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_POSITION_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchPositionGroupOptions = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }

  return dispatch => {
    dispatch(fetchPositionGroupOptionsStart())
    positionGroupAxios
      .get('/dropdown', { params })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchPositionGroupOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchPositionGroupOptionsFailed(error))
      })
  }
}

export const fetchPositionGroupOptionsStart = () => {
  return {
    type: actionTypes.FETCH_POSITION_GROUP_OPTIONS_START
  }
}

export const fetchPositionGroupOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_POSITION_GROUP_OPTIONS_SUCCESS,
    data
  }
}

export const fetchPositionGroupOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_POSITION_GROUP_OPTIONS_FAILED,
    errorMessage
  }
}
export const fetchUserOptions = () => {
  return dispatch => {
    dispatch(fetchUserOptionsStart())
    userAxios
      .get('/dropdown')
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchUserOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchUserOptionsFailed(error))
      })
  }
}

export const fetchUserOptionsStart = () => {
  return {
    type: actionTypes.FETCH_USER_OPTIONS_START
  }
}

export const fetchUserOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_USER_OPTIONS_SUCCESS,
    data
  }
}

export const fetchUserOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_USER_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchAppraisalStructureOptions = filter => {
  return dispatch => {
    let params = null
    if (filter) {
      params = filter
    }
    dispatch(fetchAppraisalStructureOptionsStart())
    structureAxios
      .get('/dropdown', { params })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          dispatch(fetchAppraisalStructureOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchAppraisalStructureOptionsFailed(error))
      })
  }
}

export const fetchAppraisalStructureOptionsStart = () => {
  return {
    type: actionTypes.FETCH_APPRAISAL_STRUCTURE_OPTIONS_START
  }
}

export const fetchAppraisalStructureOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_APPRAISAL_STRUCTURE_OPTIONS_SUCCESS,
    data
  }
}

export const fetchAppraisalStructureOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_APPRAISAL_STRUCTURE_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchKPITypeOptions = filter => {
  return dispatch => {
    dispatch(fetchKPITypeOptionsStart())
    let params = null
    if (filter) {
      params = filter
    }
    kpiTypeAxios
      .get('/dropdown', { params })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          dispatch(fetchKPITypeOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchKPITypeOptionsFailed(error))
      })
  }
}

export const fetchKPITypeOptionsStart = () => {
  return {
    type: actionTypes.FETCH_KPI_TYPE_OPTIONS_START
  }
}

export const fetchKPITypeOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_KPI_TYPE_OPTIONS_SUCCESS,
    data
  }
}

export const fetchKPITypeOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_KPI_TYPE_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchParentKPIOptions = ({ structureId, ...rest }) => {
  return dispatch => {
    dispatch(fetchParentKPIOptionsStart())
    appraisalItemAxios
      .get('/dropdown', {
        params: {
          structure_id: structureId,
          ...rest
        }
      })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          dispatch(fetchParentKPIOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchParentKPIOptionsFailed(error))
      })
  }
}

export const fetchParentKPIOptionsStart = () => {
  return {
    type: actionTypes.FETCH_PARENT_KPI_OPTIONS_START
  }
}

export const fetchParentKPIOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_PARENT_KPI_OPTIONS_SUCCESS,
    data
  }
}

export const fetchParentKPIOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_PARENT_KPI_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchUOMOptions = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchUOMOptionsStart())
    uomAxios
      .get('/dropdown', {
        params
      })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          dispatch(fetchUOMOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchUOMOptionsFailed(error))
      })
  }
}

export const fetchUOMOptionsStart = () => {
  return {
    type: actionTypes.FETCH_UOM_OPTIONS_START
  }
}

export const fetchUOMOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_UOM_OPTIONS_SUCCESS,
    data
  }
}

export const fetchUOMOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_UOM_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchPerspectiveOptions = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchPerspectiveOptionsStart())
    perspectiveAxios
      .get('/dropdown', { params })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          dispatch(fetchPerspectiveOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchAppraisalStructureOptionsFailed(error))
      })
  }
}

export const fetchPerspectiveOptionsStart = () => {
  return {
    type: actionTypes.FETCH_PERSPECTIVE_OPTIONS_START
  }
}

export const fetchPerspectiveOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_PERSPECTIVE_OPTIONS_SUCCESS,
    data
  }
}

export const fetchPerspectiveOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_PERSPECTIVE_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchValueTypeOptions = () => {
  return dispatch => {
    dispatch(fetchValueTypeOptionsStart())
    masterAxios
      .get('/value_type')
      .then(response => {
        if (response.status === 200 && response.data.success) {
          dispatch(fetchValueTypeOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchValueTypeOptionsFailed(error))
      })
  }
}

export const fetchValueTypeOptionsStart = () => {
  return {
    type: actionTypes.FETCH_VALUE_TYPE_OPTIONS_START
  }
}

export const fetchValueTypeOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_VALUE_TYPE_OPTIONS_SUCCESS,
    data
  }
}

export const fetchValueTypeOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_VALUE_TYPE_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchFunctionTypeOptions = () => {
  return dispatch => {
    dispatch(fetchFunctionTypeOptionsStart())
    masterAxios
      .get('/function_type')
      .then(response => {
        if (response.status === 200 && response.data.success) {
          dispatch(fetchFunctionTypeOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchFunctionTypeOptionsFailed(error))
      })
  }
}

export const fetchFunctionTypeOptionsStart = () => {
  return {
    type: actionTypes.FETCH_FUNCTION_TYPE_OPTIONS_START
  }
}

export const fetchFunctionTypeOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_FUNCTION_TYPE_OPTIONS_SUCCESS,
    data
  }
}

export const fetchFunctionTypeOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_FUNCTION_TYPE_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchCompetencyTypeOptions = () => {
  return dispatch => {
    dispatch(fetchCompetencyTypeOptionsStart())
    masterAxios
      .get('/competency_type')
      .then(response => {
        if (response.status === 200 && response.data.success) {
          dispatch(fetchCompetencyTypeOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchCompetencyTypeOptionsFailed(error))
      })
  }
}

export const fetchCompetencyTypeOptionsStart = () => {
  return {
    type: actionTypes.FETCH_COMPETENCY_TYPE_OPTIONS_START
  }
}

export const fetchCompetencyTypeOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_COMPETENCY_TYPE_OPTIONS_SUCCESS,
    data
  }
}

export const fetchCompetencyTypeOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_COMPETENCY_TYPE_OPTIONS_FAILED,
    errorMessage
  }
}

export const filterAppraisalStructureOptions = ({ company_id, ...rest }) => {
  return dispatch => {
    dispatch(fetchAppraisalStructureOptionsStart())
    companyAxios
      .get(`${company_id}/structures`, {
        params: rest
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(
            fetchAppraisalStructureOptionsSuccess(
              response.data.data.map(item => {
                let { structure_id, structure_name } = item
                return { structure_id, structure_name }
              })
            )
          )
        }
      })
      .catch(error => dispatch(fetchAppraisalStructureOptionsFailed(error)))
  }
}

export const filterAppraisalItemOptions = ({ structure_id, ...rest }) => {
  const params = {
    structure_id: structure_id,
    ...rest
  }
  return dispatch => {
    dispatch(fetchAppraisalItemOptionsStart())
    appraisalItemAxios
      .get('dropdown', { params })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchAppraisalItemOptionsSuccess(response.data.data))
        }
      })
      .catch(error => dispatch(fetchAppraisalItemOptionsFailed(error)))
  }
}

export const fetchAppraisalItemOptionsStart = () => {
  return {
    type: actionTypes.FETCH_APPRAISAL_ITEM_OPTIONS_START
  }
}

export const fetchAppraisalItemOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_APPRAISAL_ITEM_OPTIONS_SUCCESS,
    data
  }
}

export const fetchAppraisalItemOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_APPRAISAL_ITEM_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchStructureTypeOptions = () => {
  return dispatch => {
    dispatch(fetchStructureTypeOptionsStart())
    structureTypeAxios
      .get('/dropdown')
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchStructureTypeOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchStructureTypeOptionsFailed(error))
      })
  }
}

export const fetchStructureTypeOptionsStart = () => {
  return {
    type: actionTypes.FETCH_STRUCTURE_TYPE_OPTIONS_START
  }
}

export const fetchStructureTypeOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_STRUCTURE_TYPE_OPTIONS_SUCCESS,
    data
  }
}

export const fetchStructureTypeOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_STRUCTURE_TYPE_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchRoleOptions = () => {
  return dispatch => {
    dispatch(fetchRoleOptionsStart())
    roleAxios
      .get('/dropdown')
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchRoleOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchRoleOptionsFailed(error))
      })
  }
}

export const fetchRoleOptionsStart = () => {
  return {
    type: actionTypes.FETCH_ROLE_OPTIONS_START
  }
}

export const fetchRoleOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_ROLE_OPTIONS_SUCCESS,
    data
  }
}

export const fetchRoleOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_ROLE_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchResultTypeOptions = () => {
  return dispatch => {
    dispatch(fetchResultTypeOptionsStart())
    masterAxios
      .get('/result_type')
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchResultTypeOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchResultTypeOptionsFailed(error))
      })
  }
}

export const fetchResultTypeOptionsStart = () => {
  return {
    type: actionTypes.FETCH_RESULT_TYPE_OPTIONS_START
  }
}

export const fetchResultTypeOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_RESULT_TYPE_OPTIONS_SUCCESS,
    data
  }
}
export const fetchResultTypeOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_RESULT_TYPE_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchAccessTypeOptions = () => {
  return dispatch => {
    dispatch(fetchAccessTypeOptionsStart())
    masterAxios
      .get('/access_type')
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchAccessTypeOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchAccessTypeOptionsFailed(error))
      })
  }
}

export const fetchAccessTypeOptionsStart = () => {
  return {
    type: actionTypes.FETCH_ACCESS_TYPE_OPTIONS_START
  }
}

export const fetchAccessTypeOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_ACCESS_TYPE_OPTIONS_SUCCESS,
    data
  }
}

export const fetchAccessTypeOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_ACCESS_TYPE_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchEmployeeOptions = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchEmployeeOptionsStart())
    empAxios
      .get('/dropdown', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchEmployeeOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchEmployeeOptionsFailed(error))
      })
  }
}

export const fetchEmployeeOptionsStart = () => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_OPTIONS_START
  }
}

export const fetchEmployeeOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_OPTIONS_SUCCESS,
    data
  }
}

export const fetchEmployeeOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchAssessorGroupOptions = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchAssessorGroupOptionsStart())
    masterAxios
      .get('/assessor_group', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchAssessorGroupOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchAssessorGroupOptionsFailed(error))
      })
  }
}

export const fetchAssessorGroupOptionsStart = () => {
  return {
    type: actionTypes.FETCH_ASSESSOR_GROUP_OPTIONS_START
  }
}

export const fetchAssessorGroupOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_ASSESSOR_GROUP_OPTIONS_SUCCESS,
    data
  }
}

export const fetchAssessorGroupOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_ASSESSOR_GROUP_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchFormOptions = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchFormOptionsStart())
    formAxios
      .get('/dropdown', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchFormOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchFormOptionsFailed(error))
      })
  }
}

export const fetchFormOptionsStart = () => {
  return {
    type: actionTypes.FETCH_FORM_OPTIONS_START
  }
}

export const fetchFormOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_FORM_OPTIONS_SUCCESS,
    data
  }
}

export const fetchFormOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_FORM_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchEmpTypeOptions = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchEmpTypeOptionsStart())
    masterAxios
      .get('/emp_type', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchEmpTypeOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchEmpTypeOptionsFailed(error))
      })
  }
}

export const fetchEmpTypeOptionsStart = () => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_TYPE_OPTIONS_START
  }
}

export const fetchEmpTypeOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_TYPE_OPTIONS_SUCCESS,
    data
  }
}

export const fetchEmpTypeOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_TYPE_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchFrequencyTypeOptions = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchFrequencyTypeOptionsStart())
    masterAxios
      .get('/frequency_type', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchFrequencyTypeOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchFrequencyTypeOptionsFailed(error))
      })
  }
}

export const fetchFrequencyTypeOptionsStart = () => {
  return {
    type: actionTypes.FETCH_FREQUENCY_TYPE_OPTIONS_START
  }
}

export const fetchFrequencyTypeOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_FREQUENCY_TYPE_OPTIONS_SUCCESS,
    data
  }
}

export const fetchFrequencyTypeOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_FREQUENCY_TYPE_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchLevelGroupOptions = filterOptions => {
  return dispatch => {
    let params = null
    if (filterOptions) {
      params = filterOptions
    }
    dispatch(fetchLevelGroupOptionsStart())
    levelGroupAxios
      .get('/dropdown', { params })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchLevelGroupOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchLevelGroupOptionsFailed(error))
      })
  }
}

export const fetchLevelGroupOptionsStart = () => {
  return {
    type: actionTypes.FETCH_LEVEL_GROUP_OPTIONS_START
  }
}

export const fetchLevelGroupOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_LEVEL_GROUP_OPTIONS_SUCCESS,
    data
  }
}

export const fetchLevelGroupOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchStageOptions = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchStageOptionsStart())
    structureAxios
      .get('/stage/dropdown', { params })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchStageOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchStageOptionsFailed(error))
      })
  }
}

export const fetchStageOptionsStart = () => {
  return {
    type: actionTypes.FETCH_STAGE_OPTIONS_START
  }
}

export const fetchStageOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_STAGE_OPTIONS_SUCCESS,
    data
  }
}

export const fetchStageOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_STAGE_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchProvinceOptions = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchProvinceOptionsStart())
    dropDownAxios
      .get('/province', { params })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchProvinceOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchProvinceOptionsFailed(error))
      })
  }
}

export const fetchProvinceOptionsStart = () => {
  return {
    type: actionTypes.FETCH_PROVINCE_OPTIONS_START
  }
}

export const fetchProvinceOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_PROVINCE_OPTIONS_SUCCESS,
    data
  }
}

export const fetchProvinceOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_PROVINCE_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchPositionGroupLevelOptions = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchPositionGroupLevelOptionsStart())
    masterAxios
      .get('position_group_level', { params })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchPositionGroupLevelOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchPositionGroupLevelOptionsFailed(error))
      })
  }
}

const fetchPositionGroupLevelOptionsStart = () => {
  return {
    type: actionTypes.FETCH_POSITION_GROUP_LEVEL_OPTIONS_START
  }
}

const fetchPositionGroupLevelOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_POSITION_GROUP_LEVEL_OPTIONS_SUCCESS,
    data
  }
}

const fetchPositionGroupLevelOptionsFailed = () => {
  return {
    type: actionTypes.FETCH_POSITION_GROUP_LEVEL_OPTIONS_FAILED
  }
}

export const fetchCompetencyScoreOptions = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchCompetencyScoreOptionsStart())
    competencyScoreAxios
      .get('/dropdown', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data
          dispatch(fetchCompetencyScoreOptionsSuccess(data))
        }
      })
      .catch(e => {
        dispatch(fetchCompetencyScoreOptionsFailed())
      })
  }
}

const fetchCompetencyScoreOptionsStart = () => {
  return {
    type: actionTypes.FETCH_COMPETENCY_SCORE_OPTIONS_START
  }
}

const fetchCompetencyScoreOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_COMPETENCY_SCORE_OPTIONS_SUCCESS,
    data
  }
}

const fetchCompetencyScoreOptionsFailed = () => {
  return {
    type: actionTypes.FETCH_COMPETENCY_SCORE_OPTIONS_FAILED
  }
}

export const fetchGradeOptions = () => {
  return dispatch => {
    dispatch(fetchGradeOptionsStart())
    masterAxios
      .get('grade_list')
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchGradeOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchGradeOptionsFailed(error))
      })
  }
}

export const fetchGradeOptionsStart = () => {
  return {
    type: actionTypes.FETCH_GRADE_OPTIONS_START
  }
}

export const fetchGradeOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_GRADE_OPTIONS_SUCCESS,
    data
  }
}

export const fetchGradeOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_GRADE_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchCompetencyScoreGroupOptions = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchCompetencyScoreGroupOptionsStart())
    dropDownAxios
      .get('/competency_score_group', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data
          dispatch(fetchCompetencyScoreGroupOptionsSuccess(data))
        }
      })
      .catch(e => {
        dispatch(fetchCompetencyScoreGroupOptionsFailed())
      })
  }
}

const fetchCompetencyScoreGroupOptionsStart = () => {
  return {
    type: actionTypes.FETCH_COMPETENCY_SCORE_GROUP_OPTIONS_START
  }
}

const fetchCompetencyScoreGroupOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_COMPETENCY_SCORE_GROUP_OPTIONS_SUCCESS,
    data
  }
}

const fetchCompetencyScoreGroupOptionsFailed = () => {
  return {
    type: actionTypes.FETCH_COMPETENCY_SCORE_GROUP_OPTIONS_FAILED
  }
}

export const fetchForceRankGroupOptions = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchForceRankGroupOptionsStart())
    dropDownAxios
      .get('/force_rank_group', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data
          dispatch(fetchForceRankGroupOptionsSuccess(data))
        }
      })
      .catch(e => {
        dispatch(fetchForceRankGroupOptionsFailed())
      })
  }
}

const fetchForceRankGroupOptionsStart = () => {
  return {
    type: actionTypes.FETCH_FORCE_RANK_GROUP_OPTIONS_START
  }
}

const fetchForceRankGroupOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_FORCE_RANK_GROUP_OPTIONS_SUCCESS,
    data
  }
}

const fetchForceRankGroupOptionsFailed = () => {
  return {
    type: actionTypes.FETCH_FORCE_RANK_GROUP_OPTIONS_FAILED
  }
}

export const fetchSelfPosition = () => {
  return async dispatch => {
    dispatch(fetchSelfPositionStart())
    try {
      const response = await baseAxios.get('/auth/position')
      if (response.status === 200) {
        const data = response.data.data
        dispatch(fetchSelfPositionSuccess(data))
      }
    } catch (error) {
      dispatch(fetchSelfPositionFailed())
    }
  }
}

const fetchSelfPositionStart = () => {
  return {
    type: actionTypes.FETCH_SELF_POSITION_START
  }
}

const fetchSelfPositionSuccess = data => {
  return {
    type: actionTypes.FETCH_SELF_POSITION_SUCCESS,
    data
  }
}

const fetchSelfPositionFailed = () => {
  return {
    type: actionTypes.FETCH_SELF_POSITION_FAILED
  }
}
